import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const clientName =
    contexts.bound_form?.user?.name || i18n.t('shared:user_not_found');

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: i18n.t('shared:your_coach'),
    icon: AlarmIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:bound_form_missed.title', {
      clientName,
    }),
  };
};
